import { useState, type ReactNode } from "react";

export type DrilldownItem = {
  id: string;
  summary: ReactNode;
  detail: ReactNode;
};

export function Drilldown({ items }: { items: ReadonlyArray<DrilldownItem> }) {
  const [open, setOpen] = useState<string | null>(null);
  return (
    <div className="rounded-xl border border-line bg-canvas-2 overflow-hidden">
      {items.map((it, i) => {
        const isOpen = open === it.id;
        return (
          <div
            key={it.id}
            className={`${i > 0 ? "border-t border-line/60" : ""}`}
          >
            <button
              type="button"
              onClick={() => setOpen(isOpen ? null : it.id)}
              className="w-full text-left flex items-center justify-between gap-3 px-4 py-3 hover:bg-canvas transition"
            >
              <div className="min-w-0">{it.summary}</div>
              <span
                aria-hidden
                className={`text-ink-soft transition-transform ${isOpen ? "rotate-180" : ""}`}
              >
                ⌄
              </span>
            </button>
            {isOpen && (
              <div className="px-4 py-3 border-t border-line/40 bg-canvas/40 text-sm">
                {it.detail}
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}
